module.exports = __webpack_public_path__ + "img/instagram-icon.d0e87c07.png";